winH = $( window ).height();
winW = $( window ).width();
if ( (winW >= 1320) ) {
    const skroll = require( 'skrollr' );
    if ( winH <= 550 ) {
        winH = 550;
    }
    if ( winW >= 1320 ) {
        skroll.init( {
            forceHeight: false
        } );
    } else {
        const s = skroll.init();
        s.destroy();
    }
}
